<template>
  <global-dialog-card v-model="model" :max-width="800" :title="$t('users')">
    <div>
      <text-field
        type="number"
        v-model="search_user_id"
        required
        :label="$t('enter_user_id')"
      ></text-field>
      <p v-if="userByIdError" class="my-3" style="font-weight: bold">
        {{ userByIdError }}
      </p>
      <section v-if="search_user_id_data">
        <v-row justify="center">
          <v-col cols="5">
            <qrcode-vue
              id="qrkodstampa"
              :value="
                JSON.stringify({
                  id: this.selectedQr,
                  secure: this.selectedQrSecret,
                })
              "
              :size="160"
              level="H"
              render-as="svg"
          /></v-col>
          <v-col cols="7">
            <div
              style="color: #000 !important; font-weight: 900; margin-left: -15px"
              class="p-3"
            >
              <div>ID: {{ search_user_id_data.data.id }}</div>
              <div>
                {{
                  [
                    toLatin(search_user_id_data.data.name),
                    toLatin(search_user_id_data.data.lastname),
                  ].join(" ")
                }}
              </div>
              <div>{{ search_user_id_data.data.email }}</div>
              <div>{{ search_user_id_data.data.phone }}</div>
              <div>{{ $t("firm") }}:</div>
              <div v-for="company in search_user_id_data.data.companies">
                {{ toLatin(company.name) }}
              </div>
            </div>
          </v-col>
        </v-row>
      </section>
    </div>
    <template #actions>
      <v-btn text @click="model = false">
        {{ $t("cancel") }}
      </v-btn>
      <primary-button @click="searchUserById()" :loading="loading">
        {{ $t("search") }}
      </primary-button>
    </template>
  </global-dialog-card>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import userService from "@/services/user";
import QrcodeVue from "qrcode.vue";

export default {
  name: "CompanyEmployeeSearchDialog",
  mixins: [hasModel],
  components: {
    QrcodeVue,
  },
  data() {
    return {
      userByIdError: "",
      search_user_id: "",
      search_user_id_data: null,
      selectedQrSecret: null,
      selectedQr: null,
      loading: false,
    };
  },
  methods: {
    searchUserById() {
      this.search_user_id_data = null;
      this.userByIdError = "";
      this.loading = true;

      userService
        .searchUserById(this.search_user_id)
        .then(({ data }) => {
          if (data) {
            this.search_user_id_data = data;
            this.selectedQrSecret = data.data.qrCode;
            this.selectedQr = data.data.id;
            this.search_user_id = "";
          }
        })
        .catch((error) => {
          this.userByIdError = error.response?.data?.message || this.$t("search_error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
